import React from "react";
import "./_mainContainer.scss";

function MainContainer({ children }) {
  return <div className='mainContainer'>{children}</div>;
}

export default MainContainer;
